export default "__VITE_ASSET__isGo2Mfj__"